import { AccountBrandingLoginPageRequest } from 'vopay';
import { useEffect } from 'react';
import axios from 'axios';
import vopayApi from '@/services/api.config';
import { useDataFetchIndicator } from '..';

const { api } = vopayApi;

export default function useFetchLoginPageBranding() {
  const source = axios.CancelToken.source();
  const [, setPending] = useDataFetchIndicator();

  async function fetchLoginPageBranding(requestParams?: AccountBrandingLoginPageRequest) {
    try {
      setPending(true);

      const res = await api.fetchLoginPageBranding({ HostName: window.location.hostname, ...requestParams }, source);

      return res;
    } finally {
      setPending(false);
    }
  }

  useEffect(() => {
    return () => source.cancel();
  }, []);

  return {
    fetchLoginPageBranding,
  };
}
